export * from './authentication.service';
import { AuthenticationService } from './authentication.service';
export * from './role.service';
import { RoleService } from './role.service';
export * from './test.service';
import { TestService } from './test.service';
export * from './user.service';
import { UserService } from './user.service';
export * from './values.service';
import { ValuesService } from './values.service';
export const APIS = [AuthenticationService, RoleService, TestService, UserService, ValuesService];
